
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Coins, Plus } from "lucide-react";
import { Link } from "react-router-dom";

interface TokenPlan {
  id: string;
  tokens: number;
  price: string;
  perToken: string;
  popular: boolean;
}

export const TokenPlans = () => {
  const plans: TokenPlan[] = [
    {
      id: "starter",
      tokens: 5,
      price: "$2",
      perToken: "$0.40/token",
      popular: false
    },
    {
      id: "popular",
      tokens: 15,
      price: "$5",
      perToken: "$0.33/token",
      popular: true
    },
    {
      id: "pro",
      tokens: 40,
      price: "$10",
      perToken: "$0.25/token",
      popular: false
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 md:gap-4">
      {plans.map((plan) => (
        <Card
          key={plan.tokens}
          className={`relative overflow-hidden ${
            plan.popular ? 'border-primary shadow-lg' : ''
          }`}
        >
          {plan.popular && (
            <div className="absolute top-0 right-0 bg-primary text-primary-foreground text-[10px] md:text-xs px-1.5 md:px-2 py-0.5 md:py-1">
              Best Value
            </div>
          )}
          <div className="p-3 md:p-6">
            <div className="flex items-center gap-1.5 md:gap-2 mb-2 md:mb-4">
              <Coins className="h-5 w-5 md:h-6 md:w-6 text-primary" />
              <span className="text-xl md:text-2xl font-bold">{plan.tokens}</span>
              <span className="text-xs md:text-sm text-muted-foreground">tokens</span>
            </div>
            <div className="mb-3 md:mb-4">
              <div className="text-xl md:text-2xl font-bold">{plan.price}</div>
              <div className="text-xs md:text-sm text-muted-foreground">{plan.perToken}</div>
            </div>
            <Link
              to={`/checkout?plan=${plan.id}`}
              className="block w-full"
            >
              <Button
                className="w-full h-9 md:h-10 text-sm md:text-base"
                variant={plan.popular ? "default" : "outline"}
              >
                <Plus className="h-3.5 w-3.5 md:h-4 md:w-4 mr-1.5 md:mr-2" />
                Buy Tokens
              </Button>
            </Link>
          </div>
        </Card>
      ))}
    </div>
  );
};
